module.exports = __webpack_public_path__ + "static/media/img-1.d6aea7a6.jpg";